var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDynamic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "70%",
    viewBox: "0 0 317.77 317.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M428.09,182.72V231c-.16.11-.4.19-.47.34-3.59,8.43-8,11.35-17.05,11.35H357v10h3.63q25.65,0,51.3,0a21.84,21.84,0,0,1,4.27.42c6.29,1.3,9.6,5.8,11.93,11.3v48.27c-.2.22-.47.4-.57.65-3.09,7.78-7.89,11.06-16.26,11.07q-17.14,0-34.28,0h-3.31c1.13,5,4.14,6.35,8.58,4.22,6.8-3.25,13.33-2.19,18.69,3.08,2.71,2.67,5.24,5.54,8.1,8,6.6,5.76,8.13,14,4.1,21.12a4.9,4.9,0,0,0,2.79,7.31c6.36,1.78,10.06,6,12.16,12v21.65c-2.2,5-5.15,9.26-10.71,11.06-4.9,1.59-5.94,4.22-3.7,8.91a15.41,15.41,0,0,1-3,18.19c-2.81,2.87-5.84,5.54-8.48,8.56-5.59,6.4-13.72,7.95-20.87,4-2.9-1.62-6.26-.52-7.15,2.48-1.84,6.22-5.88,10.1-11.7,12.44H340.85c-5.39-1.88-9.58-5-11.49-10.7-1.66-4.93-4.24-6-8.92-3.71a15.46,15.46,0,0,1-18.21-3q-5.1-5-10.06-10.06a15.43,15.43,0,0,1-2.92-18.21c2.23-4.65,1.14-7.23-3.78-8.94a15.63,15.63,0,0,1-10.76-14.72c-.07-4.94-.15-9.9,0-14.84a15,15,0,0,1,8.59-13.65c7.76-4,7.71-3.89,5-12.28-.6-1.88-1.49-2.34-3.27-2.3-4.23.1-8.45,0-12.68,0h-7.7v4.56q0,45.92,0,91.83a15.54,15.54,0,0,1-10.17,15.12,17.44,17.44,0,0,0-1.54.82H123.07a3.21,3.21,0,0,0-.69-.55c-7.71-2.93-11.06-7.74-11.06-15.93q0-50.12,0-100.23a18.6,18.6,0,0,1,.33-4.29,15.43,15.43,0,0,1,15.28-12c4.91,0,9.81,0,14.86,0v-101c0-22.18,0-44.35,0-66.52,0-9.47,6.47-16.31,15.3-16.31q92.16,0,184.34,0a15,15,0,0,1,14.9,13c.33,2.39.38,4.83.58,7.4h3.31q25.83,0,51.65,0a21.25,21.25,0,0,1,4.58.46C422.62,172.83,425.85,177.28,428.09,182.72ZM152.4,202V334.4h3.9q45.94,0,91.87,0c6.56,0,11.44,2.73,14.78,8.41a4.19,4.19,0,0,0,2.94,1.85c7.22.16,14.44.13,21.65,0a4.56,4.56,0,0,0,2.9-1.18c3.31-3.24,6.56-6.56,9.68-10,6.15-6.75,13.11-8.73,21.59-4.4,3.6,1.84,7-.44,7.32-4.71h-3.39c-11.65,0-23.3,0-34.95,0-9.29,0-16-6.72-16-16q0-19.65,0-39.29c0-9.92,6.53-16.41,16.48-16.42q25.83,0,51.66,0h3.26v-10h-3.94c-17.11,0-34.23,0-51.35,0-8.22,0-14.56-5.22-15.89-13.15a44.17,44.17,0,0,1-.22-7.1c0-6.78,0-13.55,0-20.47ZM187.72,457h59.67c5.5,0,6.87-1.4,6.88-7V351.7c0-5.3-1.52-6.86-6.7-6.86H128.84c-5.89,0-7.14,1.28-7.14,7.31q0,49,0,98c0,5.55,1.28,6.82,7,6.82Zm230-66.29c0-2.27-.05-4.54,0-6.81.08-2.88-1.32-4.59-4-5.55-10.67-3.85-14.38-12.66-9.57-22.88,1.26-2.69,1-4.92-1.15-7-3.09-3-6.19-6.06-9.18-9.18-2.28-2.38-4.69-2.52-7.54-1.13-9.44,4.59-19.12.48-22.49-9.57-.95-2.82-2.67-4.24-5.67-4.2-4.43.05-8.86.08-13.29,0-3.17-.06-4.91,1.47-5.88,4.37-3.37,10-12.94,13.95-22.58,9.34-2.73-1.31-5.11-1.15-7.29,1.09q-4.55,4.65-9.19,9.19c-2.23,2.18-2.44,4.54-1.13,7.29,4.68,9.77.76,19-9.58,22.67-2.74,1-4.17,2.77-4.1,5.79.09,4.43.06,8.87,0,13.3,0,3,1.33,4.73,4.16,5.69,10.24,3.46,14.16,12.91,9.49,22.75-1.3,2.75-1,5.09,1.23,7.27,3.12,3,6.15,6.09,9.18,9.18a5.5,5.5,0,0,0,7,1.19c10.26-4.82,19.05-1.15,22.91,9.51.94,2.62,2.61,4.05,5.52,4,4.63-.07,9.27,0,13.91,0,2.75,0,4.36-1.38,5.26-3.9,3.79-10.65,12.72-14.44,22.88-9.65,2.69,1.27,4.92,1,7-1.1q4.67-4.73,9.4-9.4c2.09-2.07,2.42-4.27,1.13-7-4.8-10.14-1-19.12,9.59-22.9,2.67-1,4-2.68,3.94-5.55C417.65,395.25,417.7,393,417.7,390.72ZM351.6,181.37q-30.17,0-60.32,0c-4.51,0-6.13,1.64-6.14,6.13q0,19.17,0,38.36c0,4.61,1.71,6.37,6.28,6.37h120c4.63,0,6.26-1.65,6.27-6.36q0-18.87,0-37.74c0-5.41-1.33-6.77-6.72-6.77ZM351.68,314q29.85,0,59.7,0c4.72,0,6.31-1.57,6.32-6.26q0-19.18,0-38.37c0-4.68-1.59-6.22-6.36-6.22H291.64c-4.9,0-6.5,1.58-6.5,6.41q0,18.87,0,37.74c0,5.22,1.53,6.7,6.85,6.7Q321.84,314,351.68,314Zm-5.34-143v-2.88c0-5.62-1.49-7.16-7.09-7.16-6,0-11.95,0-17.93,0H159c-5.2,0-6.77,1.6-6.78,6.85,0,3.09,0,6.18,0,9.28v14.11H274.69c0-1.24.06-2.27,0-3.28-.64-10,7.47-17.3,16.87-17,15,.42,30.1.11,45.15.11Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.5,467.39c5.82-2.34,9.86-6.22,11.7-12.44.89-3,4.25-4.1,7.15-2.48,7.15,4,15.28,2.44,20.87-4,2.64-3,5.67-5.69,8.48-8.56a15.41,15.41,0,0,0,3-18.19c-2.24-4.69-1.2-7.32,3.7-8.91,5.56-1.8,8.51-6,10.71-11.06",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.4,202H274.69c0,6.92,0,13.69,0,20.47a44.17,44.17,0,0,0,.22,7.1c1.33,7.93,7.67,13.13,15.89,13.15,17.12,0,34.24,0,51.35,0h3.94v10h-3.26q-25.83,0-51.66,0c-9.95,0-16.46,6.5-16.48,16.42q0,19.65,0,39.29c0,9.28,6.7,16,16,16,11.65,0,23.3,0,34.95,0H329c-.36,4.27-3.72,6.55-7.32,4.71-8.48-4.33-15.44-2.35-21.59,4.4-3.12,3.42-6.37,6.74-9.68,10a4.56,4.56,0,0,1-2.9,1.18c-7.21.1-14.43.13-21.65,0a4.19,4.19,0,0,1-2.94-1.85c-3.34-5.68-8.22-8.41-14.78-8.41q-45.93,0-91.87,0h-3.9Zm112.06,81.5V212H162.51v71.47Zm-102,40.69h102v-10h-102Zm20.47-30.51V303.8h81.51V293.63Zm-10.47.09h-10v10.07h10Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.72,457H128.67c-5.69,0-7-1.27-7-6.82q0-49,0-98c0-6,1.25-7.31,7.14-7.31H247.57c5.18,0,6.7,1.56,6.7,6.86V450c0,5.56-1.38,7-6.88,7Zm25.67-102v81.35h-10v-60.9h-30.8v60.91H162.49V395.87H132v50.9H244.09V355Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.7,390.72c0,2.26-.05,4.53,0,6.8.08,2.87-1.27,4.59-3.94,5.55-10.6,3.78-14.39,12.76-9.59,22.9,1.29,2.72,1,4.92-1.13,7q-4.73,4.68-9.4,9.4c-2.08,2.11-4.31,2.37-7,1.1-10.16-4.79-19.09-1-22.88,9.65-.9,2.52-2.51,3.91-5.26,3.9-4.64,0-9.28-.06-13.91,0-2.91.05-4.58-1.38-5.52-4-3.86-10.66-12.65-14.33-22.91-9.51a5.5,5.5,0,0,1-7-1.19c-3-3.09-6.06-6.19-9.18-9.18-2.27-2.18-2.53-4.52-1.23-7.27,4.67-9.84.75-19.29-9.49-22.75-2.83-1-4.2-2.71-4.16-5.69.05-4.43.08-8.87,0-13.3-.07-3,1.36-4.81,4.1-5.79,10.34-3.67,14.26-12.9,9.58-22.67-1.31-2.75-1.1-5.11,1.13-7.29q4.65-4.54,9.19-9.19c2.18-2.24,4.56-2.4,7.29-1.09,9.64,4.61,19.21.66,22.58-9.34,1-2.9,2.71-4.43,5.88-4.37,4.43.09,8.86.06,13.29,0,3,0,4.72,1.38,5.67,4.2,3.37,10,13.05,14.16,22.49,9.57,2.85-1.39,5.26-1.25,7.54,1.13,3,3.12,6.09,6.15,9.18,9.18,2.12,2.08,2.41,4.31,1.15,7-4.81,10.22-1.1,19,9.57,22.88,2.64,1,4,2.67,4,5.55C417.65,386.18,417.7,388.45,417.7,390.72Zm-112.25-.08a46.26,46.26,0,0,0,45.83,46.24c25.16.18,46.38-21,46.3-46.21a46.07,46.07,0,0,0-92.13,0Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.6,181.37H411c5.39,0,6.72,1.36,6.72,6.77q0,18.87,0,37.74c0,4.71-1.64,6.36-6.27,6.36h-120c-4.57,0-6.28-1.76-6.28-6.37q0-19.19,0-38.36c0-4.49,1.63-6.12,6.14-6.13Q321.45,181.35,351.6,181.37Zm-56.29,10.11V222h30.45v-30.5ZM407.58,212H336.26v10h71.32Zm-51-10.4h50.88v-10H356.59Zm-20.33-10v10h9.94v-10Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.68,314q-29.85,0-59.69,0c-5.32,0-6.85-1.48-6.85-6.7q0-18.87,0-37.74c0-4.83,1.6-6.41,6.5-6.41h119.7c4.77,0,6.35,1.54,6.36,6.22q0,19.19,0,38.37c0,4.69-1.6,6.26-6.32,6.26Q381.53,314,351.68,314Zm-56.29-40.74v30.51h30.38V273.22Zm40.76,30.52h71.32v-10H336.15Zm71.43-30.46h-51v10h51Zm-71.44,10H346.2v-10H336.14Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.34,171H336.7c-15.05,0-30.11.31-45.15-.11-9.4-.27-17.51,7-16.87,17,.07,1,0,2,0,3.28H152.18V177.06c0-3.1,0-6.19,0-9.28,0-5.25,1.58-6.85,6.78-6.85H321.32c6,0,11.95,0,17.93,0,5.6,0,7.12,1.54,7.09,7.16Zm-183.82.1v10h9.88v-10Zm30.32,10.16v-10H183v10Zm10.55-10.14v10h9.91v-10Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.46,283.45H162.51V212H264.46Zm-10.3-60.93H172.79V272.9h81.37Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.46,324.14v-10h102v10Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.93,293.63h81.51V303.8H182.93Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.46,293.72v10.07h-10V293.72Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39,355h30.7v91.78H132v-50.9h30.53v40.48h10.06V375.44h30.8v60.9h10Zm10.67,10.38v71h9.58v-71Zm-40.94,70.95h9.66v-50.4h-9.66Zm-31.2.11V406.35h-9.54v30.08Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "none",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.45,390.64a46.07,46.07,0,0,1,92.13,0c.08,25.21-21.14,46.39-46.3,46.21A46.26,46.26,0,0,1,305.45,390.64Zm30.81-.26a15.32,15.32,0,0,0,14.91,15.67c8.19.24,15.41-6.74,15.59-15.09a15.35,15.35,0,0,0-14.86-15.41A15.06,15.06,0,0,0,336.26,390.38Zm-5.9-29.07,0,1.3c1.93,1.84,3.64,4,5.83,5.45,3.34,2.22,5.46-2.11,8.54-2.17.53,0,1.47-1.08,1.51-1.71.17-2.83.07-5.68.07-9.52ZM326,385.53c1.17-2.72,2.3-5.12,3.22-7.61a2.77,2.77,0,0,0-.29-2.33c-1.8-2.07-3.79-4-6.5-6.75-2.47,5.91-4.62,11.08-7,16.69Zm12,27.23-7.78,7.36,16.17,6.66c0-3.87.09-6.63-.07-9.39a2.79,2.79,0,0,0-1.48-1.89C342.39,414.4,339.88,413.51,338,412.76Zm49.6-27.16c-2.46-5.8-4.64-10.94-6.89-16.26l-7.46,7.21c1.05,2.68,1.94,5.18,3,7.61a2.53,2.53,0,0,0,1.67,1.38C380.72,385.68,383.58,385.6,387.55,385.6Zm-14.22,18.48,7.48,7.88,6.56-15.71c-1.76-.13-2.66-.15-3.54-.27-4.62-.63-8.5-.17-9.27,5.65A7.11,7.11,0,0,1,373.33,404.08Zm-.55,16-7.22-7.57c-2.56,1-4.95,1.93-7.28,3-.62.28-1.45,1-1.48,1.56-.15,2.92-.07,5.85-.07,9.76ZM357,354.81c-.18,1.64-.31,2.34-.31,3,0,2.15-.08,4.31,0,6.46.08,1.54,8.46,5,9.7,4.09a2.19,2.19,0,0,0,.23-.21l6.74-6.45Zm-35,57,1.43.49c2-2.28,4-4.56,5.95-6.87a1.34,1.34,0,0,0,.26-1.11c-1-2.56-2.06-5.11-3.19-7.62a1.57,1.57,0,0,0-1.23-.65c-2.94-.06-5.88,0-9.8,0Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.31,191.48h30.45V222H295.31Zm10.48,10.46v9.65h9.52v-9.65Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.58,212v10H336.26V212Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.59,201.58v-10h50.88v10Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.26,191.56h9.94v10h-9.94Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.39,273.22h30.38v30.51H295.39Zm10.39,10.44v9.64h9.53v-9.64Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "#fff",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.15,303.74v-10h71.32v10Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.58,273.28v10h-51v-10Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.14,283.3v-10H346.2v10Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.52,171.07h9.88v10h-9.88Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.84,181.23H183v-10h9.89Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.39,171.09h9.91v10h-9.91Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.16,222.52V272.9H172.79V222.52Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.06,365.37h9.58v71h-9.58Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.12,436.32v-50.4h9.66v50.4Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.92,436.43h-9.54V406.35h9.54Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.26,390.38a15.06,15.06,0,0,1,15.64-14.83A15.35,15.35,0,0,1,366.76,391c-.18,8.35-7.4,15.33-15.59,15.09A15.32,15.32,0,0,1,336.26,390.38Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.36,361.31l16-6.65c0,3.84.1,6.69-.07,9.52,0,.63-1,1.71-1.51,1.71-3.08.06-5.2,4.39-8.54,2.17-2.19-1.45-3.9-3.61-5.83-5.45Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,385.53H315.45c2.34-5.61,4.49-10.78,7-16.69,2.71,2.78,4.7,4.68,6.5,6.75a2.77,2.77,0,0,1,.29,2.33C328.28,380.41,327.15,382.81,326,385.53Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,412.76c1.93.75,4.44,1.64,6.84,2.74a2.79,2.79,0,0,1,1.48,1.89c.16,2.76.07,5.52.07,9.39l-16.17-6.66Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.55,385.6c-4,0-6.83.08-9.67-.06a2.53,2.53,0,0,1-1.67-1.38c-1.07-2.43-2-4.93-3-7.61l7.46-7.21C382.91,374.66,385.09,379.8,387.55,385.6Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.33,404.08a7.11,7.11,0,0,0,1.23-2.45c.77-5.82,4.65-6.28,9.27-5.65.88.12,1.78.14,3.54.27L380.81,412Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.78,420l-16,6.74c0-3.91-.08-6.84.07-9.76,0-.56.86-1.28,1.48-1.56,2.33-1.06,4.72-2,7.28-3Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,354.81l16.4,6.93-6.74,6.45a2.19,2.19,0,0,1-.23.21c-1.24.91-9.62-2.55-9.7-4.09-.12-2.15-.06-4.31,0-6.46C356.71,357.15,356.84,356.45,357,354.81Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,411.81,315.43,396c3.92,0,6.86,0,9.8,0a1.57,1.57,0,0,1,1.23.65c1.13,2.51,2.18,5.06,3.19,7.62a1.34,1.34,0,0,1-.26,1.11c-2,2.31-4,4.59-5.95,6.87Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)",
      stroke: "var(--primary)",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.79,201.94h9.52v9.65h-9.52Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.78,283.66h9.53v9.64h-9.53Z",
    transform: "translate(-110.81 -150.04)",
    style: {
      fill: "var(--primary)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamic);
export default __webpack_public_path__ + "static/media/dynamic.0735504cc55940256a96efec2c297f23.svg";
export { ForwardRef as ReactComponent };